import ItemPage from "./ItemPage";

export default ItemPage;
